import React from 'react';
import './Footer.css';
export default function Footer() {
    return (
        <div className="footer-wrapper" id="casebook-footer-wrapper">
            <footer id="footer" className="footer" role="contentinfo">
                <div className="row footer-container">
                    <div className="col-xs-12 col-sm-4 col-md-3 col-lg-3 no-padding footer-wk-logo" style={{ display: "block" }}>
                        <img data-testid="aspenLogo" alt="Aspen Publishing" style={{ visibility: "visible" }} src={`${process.env.PUBLIC_URL}/images/wk-logo.png`} />
                    </div>
                    <div className="footer-link col-xs-12 col-sm-8 col-md-8 col-lg-8 no-padding" style={{ display: "block" }}>
                        <nav className="pull-right navigationFooter_rsk" role="navigation" aria-label="Desktop View">
                            <a style={{ textDecoration: "underline" }} title="About Aspen Publishing" aria-label="About Aspen Publishing"
                                target="_blank" href="https://www.aspenpublishing.com/about-us/about-aspen-publishing"> About Aspen Publishing
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="Press Room" aria-label="Press Room"
                                target="_blank" href="https://www.aspenpublishing.com/wk-resources/press-room"> Press Room
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="End User License Agreement" aria-label="End User License Agreement"
                                target="_blank" href="/terms"> End User License Agreement
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="Privacy Statement" aria-label="Privacy Statement"
                                target="_blank" href="/privacy"> Privacy Statement
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="California Disclosure" aria-label="California Disclosure"
                                target="_blank" href="/privacy-california"> California Disclosure
                            </a>
                            <span> | © {(new Date().getFullYear())} Aspen Publishing</span>
                        </nav>
                    </div>
                    <div className="footer-link-mobile col-xs-12 col-sm-8 col-md-8 no-padding" style={{ display: "none" }}>
                        <nav className="pull-right" role="navigation" aria-label="Mobile View">
                            <a style={{ textDecoration: "underline" }} title="About Aspen Publishing" aria-label="About Aspen Publishing"
                                target="_blank" href="https://www.aspenpublishing.com/about-us/about-aspen-publishing"> About Aspen Publishing
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="Press Room" aria-label="Press Room"
                                target="_blank" href="https://www.aspenpublishing.com/wk-resources/press-room"> Press Room
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="End User License Agreement" aria-label="End User License Agreement"
                                target="_blank" href="/terms"> End User License Agreement
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="Privacy Statement" aria-label="Privacy Statement"
                                target="_blank" href="/privacy"> Privacy Statement
                            </a> |
                            <a style={{ textDecoration: "underline" }} title="California Disclosure" aria-label="California Disclosure"
                                target="_blank" href="/privacy-california"> California Disclosure
                            </a>
                        </nav>
                        <div>
                            <span className="footer-copyright-mobile"> © {(new Date().getFullYear())} Aspen Publishing</span>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4 no-padding footer-wk-logo-mobile" style={{ display: "none" }}>
                        <img alt="Aspen Publishing" src={`${process.env.PUBLIC_URL}/images/wk-logo.png`} />
                    </div>
                </div>
                <iframe id="ifrm" style={{ display: "none", position: "relative", left: "-3500px" }} title="Caseconnect" src=""></iframe>
            </footer>
        </div>
    )
}